<template>
  <div class="tabs_box">
    <div class="arr_left" @click="moveleft" v-show="tags.length > 10">
    <el-button type="text" :disabled="disableLeft">
      <i class="el-icon-arrow-left" style="color: #c6cddb"></i>
    </el-button>
    </div>
    <div class="tabs">
      <el-tag
        v-for="(tag, index) in tags"
        :key="tag.name"
        :class="
          selectMeu == '/' + tag.path
            ? index == 0
              ? 'common_tab moveBox'
              : 'common_tab'
            : index == 0
            ? 'moveBox'
            : ''
        "
        size="small"
        :closable="tag.name !== 'home'"
        :disable-transitions="false"
        @close="handleClose(tag, index)"
        @click="changeMenu(tag)"
        :effect="$route.name === tag.name ? 'dark' : 'plain'"
      >
        <el-tooltip
          class="item"
          effect="dark"
          :content="tag.name"
          placement="top"
        >
          <span class="tab_names">{{ tag.name }}</span>
        </el-tooltip>
      </el-tag>
    </div>
    <div class="arr_right" @click="moveRight" v-show="tags.length > 10">
      <el-button type="text" :disabled="this.initLeft==0"><i class="el-icon-arrow-right" style="color: #c6cddb"></i></el-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      selectMeu: "", //当前路由
      initLeft: 0, //初始化值
      disableLeft:false
    };
  },
  computed: {
    ...mapState({
      tags: (state) => state.tab.tabsList,
    }),
  },
  mounted() {
    console.log("当前路由", this.$route.path);
    this.selectMeu = this.$route.path;
  },
  watch:{
    initLeft(data){
      let num = (this.tags.length - 10) * -134; //只能移动几次
      if(data==num){
        this.disableLeft=true
      }else{
        this.disableLeft=false
      }
    }
  },
  methods: {
    // 左移
    moveleft() {
      let tagsLength = this.tags.length;
      let num = (tagsLength - 10) * -134; //只能移动几次
      console.log(tagsLength);
      if (this.initLeft > num) {
        this.initLeft = this.initLeft - 134;
        document.querySelector(".moveBox").style.marginLeft =
          this.initLeft + "px";
      }
    },
    // 右移动
    moveRight() {
      if (this.initLeft != 0) {
        this.initLeft = this.initLeft + 134;
        document.querySelector(".moveBox").style.marginLeft =
          this.initLeft + "px";
      }
    },
    // 语法糖
    ...mapMutations({
      close: "closeTab",
    }),
    //关闭标签
    handleClose(tag, index) {
      let length = this.tags.length - 1;
      this.initLeft=0
      //vuex调方法的另一种写法
      this.close(tag);
      // 如果关闭的标签不是当前路由的话，就不跳转
      if (('/'+tag.path) !== this.$route.path) {
        return;
      }
      console.log(this.tags[index]);
      // 关闭的标签是最右边的话，往左边跳转一个
      if (index === length) {
        if(this.tags[index-1]){
          this.$router.push({ path:'/'+ this.tags[index - 1].path });
        }
      } else {
        if(this.tags[index]){
          // 否则往右边跳转
        this.$router.push({ path:'/'+ this.tags[index].path });
        }
        
      }
    },
    //选择标签跳转路由
    changeMenu(item) {
      if (this.selectMeu != "/" + item.path) {
        this.$router.push("/" + item.path);
        this.$store.commit("selectMenu", item);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab_names {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  white-space: nowrap;
  display: inline-block;
  width: 80px;
  line-height: 32px;
  text-align: center;
}
.moveBox {
  margin-left: 0;
}
.arr_left {
  width: 18px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: absolute;
  left: -6px;
}
.arr_right {
  width: 18px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: absolute;
  left: 1324px;
}
::v-deep .el-carousel {
  height: 32px;
  .el-carousel__container {
    height: 32px;
  }
}
.el-carousel__item {
  display: flex;
}
.el-carousel__container {
  height: 32px;
}
.common_tab {
  background-color: #ecf5ff !important;
  color: #2771fa !important;
}
.tabs_box {
  width: 1318px;
  height: 32px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
}
.tabs {
  width: 1318px;
  height: 32px;
  overflow: hidden;
  padding: 20px 20px 20px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: 20px;
  .el-tag {
    margin-right: 6px;
    cursor: pointer;
  }
}
.tabs::-webkit-scrollbar {
  display: none;
}
.el-tag--plain {
  border: 0 solid #fff;
  background-color: #f6f8fc;
  padding: 0 14px;
  line-height: 16px;
  height: 32px;
  font-size: 14px;
  color: #222;
  font-weight: 400;
  border-radius: 4px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
::v-deep .el-tag--plain .el-tag__close {
  color: #aab3c5;
  font-size: 16px;
}
::v-deep .el-tag--plain .el-tag__close:hover {
  color: #fff;
  background-color: #aab3c5;
}
</style>
